export default __webpack_public_path__ + "static/ECEE-2dc6b65457f0ca892934b29a2487bf20.jpg";